// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loader {
  bottom: 0;
  height: 87.5px;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 87.5px;
  z-index: 10000;
}

#loader .dot {
  bottom: 0;
  height: 100%;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 43.75px;
  z-index: 10001;
}

#loader .dot::before {
  border-radius: 100%;
  content: "";
  height: 43.75px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transform: scale(0);
  width: 43.75px;
}

#loader .dot:nth-child(7n+1) {
  transform: rotate(45deg);
}

#loader .dot:nth-child(7n+1)::before {
  animation: 0.8s linear 0.1s normal none infinite running load;
  background: #00ff80 none repeat scroll 0 0;
}

#loader .dot:nth-child(7n+2) {
  transform: rotate(90deg);
}

#loader .dot:nth-child(7n+2)::before {
  animation: 0.8s linear 0.2s normal none infinite running load;
  background: #00ffea none repeat scroll 0 0;
}

#loader .dot:nth-child(7n+3) {
  transform: rotate(135deg);
}

#loader .dot:nth-child(7n+3)::before {
  animation: 0.8s linear 0.3s normal none infinite running load;
  background: #00aaff none repeat scroll 0 0;
}

#loader .dot:nth-child(7n+4) {
  transform: rotate(180deg);
}

#loader .dot:nth-child(7n+4)::before {
  animation: 0.8s linear 0.4s normal none infinite running load;
  background: #0040ff none repeat scroll 0 0;
}

#loader .dot:nth-child(7n+5) {
  transform: rotate(225deg);
}

#loader .dot:nth-child(7n+5)::before {
  animation: 0.8s linear 0.5s normal none infinite running load;
  background: #2a00ff none repeat scroll 0 0;
}

#loader .dot:nth-child(7n+6) {
  transform: rotate(270deg);
}

#loader .dot:nth-child(7n+6)::before {
  animation: 0.8s linear 0.6s normal none infinite running load;
  background: #9500ff none repeat scroll 0 0;
}

#loader .dot:nth-child(7n+7) {
  transform: rotate(315deg);
}

#loader .dot:nth-child(7n+7)::before {
  animation: 0.8s linear 0.7s normal none infinite running load;
  background: magenta none repeat scroll 0 0;
}

#loader .dot:nth-child(7n+8) {
  transform: rotate(360deg);
}

#loader .dot:nth-child(7n+8)::before {
  animation: 0.8s linear 0.8s normal none infinite running load;
  background: #ff0095 none repeat scroll 0 0;
}

#loader .loading {
  background-position: 50% 50%;
  background-repeat: no-repeat;
  bottom: -40px;
  height: 20px;
  left: 0;
  position: absolute;
  right: 0;
  width: 180px;
}

@keyframes load {
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
@keyframes load {
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
.spinner-message {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/common/spinner/spinner.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,cAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,WAAA;EACA,eAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,6DAAA;EACA,0CAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,6DAAA;EACA,0CAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,6DAAA;EACA,0CAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,6DAAA;EACA,0CAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,6DAAA;EACA,0CAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,6DAAA;EACA,0CAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,6DAAA;EACA,0CAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,6DAAA;EACA,0CAAA;AACF;;AAEA;EACE,4BAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,mBAAA;EACF;AACF;AAEA;EACE;IACE,UAAA;IACA,mBAAA;EAAF;AACF;AAGA;EACE,kBAAA;AADF","sourcesContent":["#loader {\n  bottom: 0;\n  height: 87.5px;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 87.5px;\n  z-index: 10000;\n}\n\n#loader .dot {\n  bottom: 0;\n  height: 100%;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 43.75px;\n  z-index: 10001;\n}\n\n#loader .dot::before {\n  border-radius: 100%;\n  content: \"\";\n  height: 43.75px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transform: scale(0);\n  width: 43.75px;\n}\n\n#loader .dot:nth-child(7n+1) {\n  transform: rotate(45deg);\n}\n\n#loader .dot:nth-child(7n+1)::before {\n  animation: 0.8s linear 0.1s normal none infinite running load;\n  background: #00ff80 none repeat scroll 0 0;\n}\n\n#loader .dot:nth-child(7n+2) {\n  transform: rotate(90deg);\n}\n\n#loader .dot:nth-child(7n+2)::before {\n  animation: 0.8s linear 0.2s normal none infinite running load;\n  background: #00ffea none repeat scroll 0 0;\n}\n\n#loader .dot:nth-child(7n+3) {\n  transform: rotate(135deg);\n}\n\n#loader .dot:nth-child(7n+3)::before {\n  animation: 0.8s linear 0.3s normal none infinite running load;\n  background: #00aaff none repeat scroll 0 0;\n}\n\n#loader .dot:nth-child(7n+4) {\n  transform: rotate(180deg);\n}\n\n#loader .dot:nth-child(7n+4)::before {\n  animation: 0.8s linear 0.4s normal none infinite running load;\n  background: #0040ff none repeat scroll 0 0;\n}\n\n#loader .dot:nth-child(7n+5) {\n  transform: rotate(225deg);\n}\n\n#loader .dot:nth-child(7n+5)::before {\n  animation: 0.8s linear 0.5s normal none infinite running load;\n  background: #2a00ff none repeat scroll 0 0;\n}\n\n#loader .dot:nth-child(7n+6) {\n  transform: rotate(270deg);\n}\n\n#loader .dot:nth-child(7n+6)::before {\n  animation: 0.8s linear 0.6s normal none infinite running load;\n  background: #9500ff none repeat scroll 0 0;\n}\n\n#loader .dot:nth-child(7n+7) {\n  transform: rotate(315deg);\n}\n\n#loader .dot:nth-child(7n+7)::before {\n  animation: 0.8s linear 0.7s normal none infinite running load;\n  background: magenta none repeat scroll 0 0;\n}\n\n#loader .dot:nth-child(7n+8) {\n  transform: rotate(360deg);\n}\n\n#loader .dot:nth-child(7n+8)::before {\n  animation: 0.8s linear 0.8s normal none infinite running load;\n  background: #ff0095 none repeat scroll 0 0;\n}\n\n#loader .loading {\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  bottom: -40px;\n  height: 20px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  width: 180px;\n}\n\n@keyframes load {\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n}\n\n@keyframes load {\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n}\n\n.spinner-message {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
